import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";

import SellerReviewsHeader from "@components/Seller/SellerReviews/SellerReviewsHeader";
import SellerReviewList from "@components/Seller/SellerReviews/SellerReviewList";
import { getSellerReviewsApi } from "@lib/api";
import Loading from "@components/Loading";
import { apiCall } from "@store/app/actions";

const SellerReviews = ({ seller_id, reviewsSummary, apiCall }) => {
  const [reviews, setReviews] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);

  const getSellerReviews = useCallback(async () => {
    setIsLoading(true);
    const payload = { seller_id, page };

    const req = await apiCall({
      apiCall: getSellerReviewsApi,
      apiArgs: [payload],
      formatResponse: (response) => response.data,
      returnResponse: true,
    });
    setReviews(req);
    setIsLoading(false);
  }, [seller_id, page]);

  useEffect(() => {
    getSellerReviews();
  }, [page, getSellerReviews]);

  return (
    <div>
      <SellerReviewsHeader reviewsSummary={reviewsSummary} />
      {isLoading && !reviews ? (
        <Loading height={80} />
      ) : (
        <SellerReviewList reviews={reviews} setPage={setPage} />
      )}
    </div>
  );
};

export default connect(null, { apiCall })(SellerReviews);
